import { createSlice } from '@reduxjs/toolkit';

import { exportVendorCatalogue, updateVendorCatalogue } from '../../apis';

export const BuyerReviewCatalogueSlice = createSlice({


    name: 'BuyerCatalogueReview',
    initialState: {
        isLoading: false,
        buyerCatalogueReviewError: '',
        updateVendorCatalogueSuccess: false,
        updateVendorCatalogueSuccessMessage: '',
        exportVendorCatalogueSuccessMessage: ''
    },

    reducers: {
        clearBuyerCatalogueReview: (state, action) => {
            return {
                ...state,
                [action.payload.key]: action.payload.value
            }
        },
        clear: (state, action) => {
            return {
                ...state,
                [action.payload.key]: action.payload.value
            }
        }
    },

    extraReducers: (builder) => {
        builder.addCase(updateVendorCatalogue.pending, (state, action) => {
            state.updateVendorCatalogueSuccessMessage = ''
            state.isLoading = true;
        })
        builder.addCase(updateVendorCatalogue.fulfilled, (state, action) => {
            state.isLoading = false;
            state.buyerCatalogueReviewError = '';
            state.updateVendorCatalogueSuccess = true;
            state.updateVendorCatalogueSuccessMessage = action.payload.data.message
        })
        builder.addCase(updateVendorCatalogue.rejected, (state, action) => {
            state.buyerCatalogueReviewError = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(exportVendorCatalogue.pending, (state, action) => {
            state.exportVendorCatalogueSuccessMessage = ''
            state.isLoading = true;
        })
        builder.addCase(exportVendorCatalogue.fulfilled, (state, action) => {
            state.isLoading = false;
            state.exportVendorCatalogueSuccessMessage = action.payload.data.message
        })
        builder.addCase(exportVendorCatalogue.rejected, (state, action) => {
            state.buyerCatalogueReviewError = action.payload.message
            state.isLoading = false;
        })
    }
})

export const { clearBuyerCatalogueReview, clear } = BuyerReviewCatalogueSlice.actions
export default BuyerReviewCatalogueSlice.reducer